import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import BrandLogo from "./BrandLogo";
import NavMenu from "./NavMenu";
import NotificationDropdown from "./NotificationDropdown";
import UserDropdown from "./UserDropdown";
import { useDispatch, useSelector } from "react-redux";
import { uiAction } from "../../../../Redux/Slices/uiSlice";
import { fetchProfileDetails } from "../../../../Redux/Slices/OrgProfileSlice";
// import styles from "./ThemeSwitch.module.css";
const EcomHeader = () => {
  const [toggle, setToggle] = React.useState(true);
  const navigate = useNavigate();
  const projectType =
    useSelector((state) => state.uiReducers.appType) || "Business";
  const dispatch = useDispatch();
  const handleLogout = () => {
    sessionStorage.removeItem("loggedInUser");
    sessionStorage.removeItem("Apptype");
    navigate("/login", { replace: true });
    dispatch(uiAction.updateAppType("Business"));
  };
  const handleToggle = async (e) => {
    // 1. Capture the target state but DON'T update 'toggle' state yet
    const checked = e.target.checked;
    const newMode = projectType === "Ecommerce" ? "Business" : "Ecommerce";

    // 2. Open the Confirmation Dialog
    const result = await Swal.fire({
      title: `Switch to ${newMode} Mode?`,
      text: "This will change the layout and features of the application.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, switch it!",
      cancelButtonColor: "#ef4444",
      confirmButtonColor: "#22c55e",
    });

    // 3. Process the result
    if (result.isConfirmed) {
      // Save to session and update Redux
      sessionStorage.setItem("Apptype", newMode);
      dispatch(uiAction.updateAppType(newMode));

      // Update local toggle state only now
      setToggle(checked);

      // Redirect
      navigate("/dashboard", { replace: true });
    } else {
      // If cancelled, the checkbox stays where it was because we never called setToggle
      console.log("Switch cancelled");
    }
  };
  useEffect(() => {
    dispatch(fetchProfileDetails());
  }, []);
  return (
    <nav
      style={{ background: "#5d143f", zIndex: "99" }}
      className="navbar bg-org navbar-top navbar-slim justify-content-between fixed-top navbar-expand-lg  bg-org"
      id="navbarTopSlim"
      data-navbar-appearance="darker"
    >
      <div className="test-mode">
        <span>Test Mode</span>
      </div>
      <BrandLogo />
      {/* <div>
        <span>{projectType !== "Ecommerce" ? "Property" : "Ecommerce"}</span>
        <input
          checked={toggle}
          onChange={handleToggle}
          className={`form-check-input  }`}
          type="checkbox"
          role="switch"
          id="themeToggle"
        />
      </div> */}
      <div className="form-check form-switch text-white">
        <span className="ms-2 fw-semibold text-white nav-color">
          {projectType !== "Ecommerce" ? "Property Dashboard" : "Ecommerce"}
        </span>
        <input
          checked={toggle}
          onChange={handleToggle}
          className="form-check-input"
          type="checkbox"
          id="themeToggle"
        />
      </div>
      <div className="navbar-collapse navbar-top-collapse order-1 order-lg-0 justify-content-center">
        <NavMenu />
      </div>
      <NotificationDropdown />
      <UserDropdown onLogout={handleLogout} />
    </nav>
  );
};

export default EcomHeader;
